import OperatorApplicationForm from "./OperatorApplicationForm";

export default function OperatorFormScreen() {
  return <OperatorApplicationForm />;
}
